import kebabCase from "kebab-case";

type ReferralLinkReq = Readonly<{
  seoRef: string;
}>;

export function referralLink({ seoRef }: ReferralLinkReq) {
  return `https://app.brale.xyz/signup?ref=${kebabCase(seoRef)}`;
}
